import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderShield: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFolderShield"><Path d="M19.3379 11.0811L23 12.9316V16.0234C23 18.0393 21.7278 19.836 19.8262 20.5049L19.249 20.708L19 20.7949L18.751 20.708L18.1738 20.5049C16.2722 19.836 15 18.0393 15 16.0234V12.9316L18.6621 11.0811L19 10.9092L19.3379 11.0811Z" fill="currentColor"/><Path d="M12.4014 6H22V10.7451L19 9.22852L13.5 12.0088V16.0234C13.5 17.5098 14.0261 18.9052 14.9287 20H2V3H10.4014L12.4014 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderShield;
